/** Libro de demostración (datos inventados) servido como fichero estático. */
import type { WorkbookSource, WorkbookData } from '../app/ports.js';
import type { Values } from '@pf/workbook';

interface Fixture extends WorkbookData { title: string; modifiedTime: string; archive: Values; /** «Hoy» de los datos inventados */ today?: string }

export function demoSource(url = `${import.meta.env.BASE_URL}demo/workbook.json`): WorkbookSource & { today(): Promise<string> } {
  let cache: Promise<Fixture> | null = null;
  const get = () => (cache ??= fetch(url, { cache: 'no-cache' }).then(r => { if (!r.ok) throw new Error(`No se pudo cargar la demostración (${r.status})`); return r.json(); }));
  return {
    id: 'demo',
    title: async () => (await get()).title,
    modifiedTime: async () => (await get()).modifiedTime,
    readData: async () => { const f = await get(); return { ranges: f.ranges, formulas: f.formulas }; },
    readArchive: async () => (await get()).archive,
    today: async () => (await get()).today ?? '',
  };
}
